export const emptyContent = (content: string) => {
  return content === '<p><span></span></p>' ? '' : content
}
